import { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import {
	LifeCycle,
	HeadContentSymbol,
	RendererSymbol,
	ComponentsStylesOverridesSymbol,
	AppDidMountPromiseSymbol,
} from '@wix/thunderbolt-symbols'
import { RendererProps, AppProps, ClientRenderResponse, BatchingStrategy, IRendererPropsProvider } from './types'
import { HeadContent } from './HeadContent'
import { RendererPropsProvider } from './RendererPropsProvider'
import { ReactClientRenderer, appDidMountPromise } from './clientRenderer/reactClientRenderer'
import { ReactDomLoader } from './clientRenderer/reactDomLoader'
import { PageMountUnmountSubscriber } from './clientRenderer/pageMountUnmountSubscriber'
import { ClientBatchingStrategy } from './components/batchingStrategy'
import { ComponentsStylesOverrides } from './ComponentsStylesOverrides'
import { RendererPropsProviderSym, BatchingStrategySymbol } from './symbols'
import { ResetComponentsStylesOverrides } from './ResetComponentsStylesOverrides'

export const site: ContainerModuleLoader = (bind) => {
	bind(AppDidMountPromiseSymbol).toConstantValue(appDidMountPromise)
	bind(RendererSymbol).to(ReactClientRenderer)
	bind(RendererPropsProviderSym).to(RendererPropsProvider)
	bind(BatchingStrategySymbol).to(ClientBatchingStrategy)
	bind(LifeCycle.AppWillMountHandler).to(ReactDomLoader)
	bind(HeadContentSymbol).to(HeadContent)
	bind(LifeCycle.AppWillLoadPageHandler).to(PageMountUnmountSubscriber)
	bind(ComponentsStylesOverridesSymbol).to(ComponentsStylesOverrides)
}

export const page: ContainerModuleLoader = (bind) => {
	bind(LifeCycle.PageDidUnmountHandler).to(ResetComponentsStylesOverrides)
}

export {
	RendererProps,
	AppProps,
	ClientRenderResponse,
	BatchingStrategy,
	RendererPropsProviderSym,
	IRendererPropsProvider,
}

export { BatchingStrategySymbol } from './symbols'
